import React from 'react';
import { styled } from '@compiled/react';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { VIEW_MODE } from '../../../../common/constants';
import type { Metric } from '../../../../common/types';
import { ConditionTitle } from '../../../../common/ui/conditions/condition-title';
import { GoalHeader } from '../../../../common/ui/goals/goal-header';
import { GoalTitle } from '../../../../common/ui/goals/goal-title';
import { SLADisplayFormatHeader } from '../../../../common/ui/sla-display-format/sla-display-format-header';
import { SlaDisplayFormatTitle } from '../../../../common/ui/sla-display-format/sla-display-format-title';
import { ConditionListView } from './conditions';
import { GoalListView } from './goals';

type Props = {
	metric: Metric;
};

export const MetricView = ({ metric }: Props) => {
	const {
		config: { goals, definition: selectedConditions, slaDisplayFormat },
	} = metric;

	return (
		<MetricViewContainer>
			<GoalTitle />
			<table>
				<GoalHeader />
				<GoalListView goals={goals} />
			</table>
			<Box xcss={conditionContainerStyles}>
				<ConditionTitle />
				<ConditionListView conditions={selectedConditions} />
			</Box>
			<div>
				<SlaDisplayFormatTitle mode={VIEW_MODE} />
				<SLADisplayFormatHeader slaDisplayFormat={slaDisplayFormat} />
			</div>
		</MetricViewContainer>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const MetricViewContainer = styled.div({
	padding: `${token('space.150', '12px')} ${token('space.300', '24px')} ${token(
		'space.200',
		'16px',
	)} ${token('space.300', '24px')}`,
});

const conditionContainerStyles = xcss({
	paddingTop: 'space.200',
});
